module.exports = __webpack_public_path__ + "img/15.ed2ef912.png";